module.exports = __webpack_public_path__ + "static/media/chevron-right-blue.90bb1509.svg";